import { Component, OnInit } from '@angular/core';
import { PowerSupply } from "@psnb/psnb-api";
import { PowerSupplyService, AuthService } from "@psnb/services";
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../common/common.service';
import { map } from 'rxjs/operators';
import { PsImagesService } from '@psnb/services';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { PowerSupplyMoveErrorDialog } from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';
import * as FileSaver from 'file-saver';
import { DateAndLatestImage } from '../power-supply-edit/power-supply-edit.component';
import { DefaultService, PowerSupplyAlertsRequest, PowerSupplyAlertResponse } from '@psnb/psnb-api';
@Component({
  selector: 'nwt-power-supply-details',
  templateUrl: './power-supply-details.component.html',
  styleUrls: ['./power-supply-details.component.scss']
})

export class PowerSupplyDetailsComponent implements OnInit {
  panelOpenState = false;
  showProgressBar: boolean = false;
  Progressafter_load: boolean = false;
  powerSupply: PowerSupply = {};
  powerSupplyId: number = 0;
  batteryManufacturers: Map<any, string> = new Map<any, string>();
  batteryDateCodes: Map<any, string> = new Map<any, string>();
  batterySerial : Map<any, string> = new Map<any, string>();
  batteryInstallDates: Map<any, string> = new Map<any, string>();
  batteryVoltages: Map<any, string> = new Map<any, string>();
  batteryManagerModels: Array<string> = new Array<string>();
  noOfBatteries: Array<number>;
  noOfStrings: Array<number>;
  //showProgressBar: boolean = false;
  activeMacAddress: string = '';
  division: string = '';
  nodeId: number = 0;
  hierarchyPath: string = '';
  imagesLoaded: boolean = false;
  fileName: string = '';
  categoryid: any;
  lastvisitDate:any;
  logDate:any;
  detailedImage: any = null;
  macaddress:any;
  powerSupplyAlertsRequest: PowerSupplyAlertsRequest;
  showProgressBaralert: boolean = false;
  alertResult:any;
  showcount: boolean = false;
  alertResultData:any;
  noData:boolean = false;
  loghistoryData:any;
  logResult:any;
  nologData:boolean = false
  public powerSupplyErrorDialog: MatDialogRef<PowerSupplyMoveErrorDialog>;
  latestDateDetail: Array<DateAndLatestImage> = new Array<DateAndLatestImage>();
  catErrMessage: Array<string> = [];
  psCreatedDate:any;
  showLocationEnable:any;
  showTransponderEnable:any;
  showBatteryEnable:any;
  showHistoryEnable:any;
  showAlertsEnable:any;
  showPhotosEnable:any;
  showLastVisitEnable:any;
  xmRepBtnEnable:any;
  userpermissions:any;
  gpsgreaterFlag: boolean;
  parallelBatts : boolean;
  nwtTeamData : string = '';
  sfpmacData:any;
  constructor(
    private powerSupplyService: PowerSupplyService,
    private router: Router,
    private _location: Location,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private psImagesService: PsImagesService,
    private dialog: MatDialog,
    private authService: AuthService,
    private psnbApi : DefaultService,) {
    this.powerSupplyAlertsRequest = {};
    this.showProgressBar = true;
    this.route.queryParams
      .subscribe(params => {
        this.powerSupplyId = params['powerSupplyId'];
        this.macaddress = params['macAddress'];
      });
  }
  permissionlevel(level){
    if(level === CommonService.DISABLED) {
      return 1;
    } else if(level === CommonService.ENABLED){
      return 0;
    } else {
      return 2;
    }
  }

  ngOnInit() {
    //this.userpermissions = this.authService.getDecryptConfig
    this.userpermissions = JSON.parse(localStorage.getItem('user-permissions'));
    if (this.userpermissions=='' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
    }
    for (let element of this.userpermissions) {
      if (element.category === CommonService.DETAILSICONCAT && element.functionality === CommonService.DETAILSICON && element.permission != CommonService.ENABLED) {
        this.router.navigate(['/pageunauthorized']);
        return;
        }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWLOCATION) {
        this.showLocationEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWTRANSPONDER) {
        this.showTransponderEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWBATTERY) {
        this.showBatteryEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWALERTSEVENTS) {
        this.showAlertsEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWHISTORY) {
        this.showHistoryEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWLASTVISIT) {
        this.showLastVisitEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.SHOWPHOTOS) {
        this.showPhotosEnable = this.permissionlevel(element.permission);
      }
      if (element.category === CommonService.POWERSUPPLYDETAILS && element.functionality === CommonService.XM360REPORTBUTTON) {
        this.xmRepBtnEnable = this.permissionlevel(element.permission);
      }
    }
    this.parallelBatts = false;
    /*Condition based progressbar load */
    this.showProgressBar = true;
    //this.Progressafter_load = false;
    //this.getImageDetails(this.powerSupplyId);
    /*Function to get the Power Supply detailed data - Search based */
    this.powerSupplyService.getPowerSupplyById(this.powerSupplyId)
      .subscribe(result => {
        this.psCreatedDate = (result.createdDate)?new Date(result.createdDate).toLocaleString():null;
        this.getAlerts();
        this.getloghistory();
        const message = `PowerSupply Detail. PowerSupply Id: ${this.powerSupplyId}`;
        const activity = 'PowerSupply Detail';
        this.commonService.loggerPost(message, activity, 3);
        this.showProgressBar = false;
        this.Progressafter_load = true;
        this.activeMacAddress = result.macAddress;
        this.batteryManufacturers = new Map<any, string>();
        this.batteryDateCodes = new Map<any, string>();
        this.batterySerial = new Map<any, string>();
        this.batteryInstallDates = new Map<any, string>();
        this.batteryVoltages = new Map<any, string>();
        this.batteryManagerModels = new Array<string>();
          if(result.gpsLatitude == null) {
            this.gpsgreaterFlag = true;
          } else {
          let gpslat = this.commonService.decimalCount(result.gpsLatitude);
          if(gpslat > 6){
            this.gpsgreaterFlag = true;
          }else{
            this.gpsgreaterFlag = false;
          }
        }
        if(result.gpsLongitude == null) {
          this.gpsgreaterFlag = true;
        } else {
        let gpslong = this.commonService.decimalCount(result.gpsLongitude);
          if(gpslong > 6){
            this.gpsgreaterFlag = true;
          }else{
            this.gpsgreaterFlag = false;
          }
        }
        this.powerSupply = result;
        this.logDate = this.powerSupply.logDate;
        this.lastvisitDate = new Date(this.logDate).toLocaleString();
        this.numberOfBatteriesAndStrings(this.powerSupply.numberOfBatteries);
        this.getNwtName();
        this.batteryManufacturers.set("1,1", this.powerSupply.type11);
        this.batteryManufacturers.set("1,2", this.powerSupply.type12);
        this.batteryManufacturers.set("1,3", this.powerSupply.type13);
        this.batteryManufacturers.set("1,4", this.powerSupply.type14);
		    this.batteryManufacturers.set("1,5", this.powerSupply.type15);
        this.batteryManufacturers.set("1,6", this.powerSupply.type16);
        this.batteryManufacturers.set("2,1", this.powerSupply.type21);
        this.batteryManufacturers.set("2,2", this.powerSupply.type22);
        this.batteryManufacturers.set("2,3", this.powerSupply.type23);
        this.batteryManufacturers.set("2,4", this.powerSupply.type24);
        this.batteryManufacturers.set("3,1", this.powerSupply.type31);
        this.batteryManufacturers.set("3,2", this.powerSupply.type32);
        this.batteryManufacturers.set("3,3", this.powerSupply.type33);
        this.batteryManufacturers.set("3,4", this.powerSupply.type34);
        this.batteryManufacturers.set("4,1", this.powerSupply.type41);
        this.batteryManufacturers.set("4,2", this.powerSupply.type42);
        this.batteryManufacturers.set("4,3", this.powerSupply.type43);
        this.batteryManufacturers.set("4,4", this.powerSupply.type44);
        this.batteryManufacturers.set("5,1", this.powerSupply.type51);
        this.batteryManufacturers.set("5,2", this.powerSupply.type52);
        this.batteryManufacturers.set("5,3", this.powerSupply.type53);
        this.batteryManufacturers.set("5,4", this.powerSupply.type54);
        this.batteryManufacturers.set("6,1", this.powerSupply.type61);
        this.batteryManufacturers.set("6,2", this.powerSupply.type62);
        this.batteryManufacturers.set("6,3", this.powerSupply.type63);
        this.batteryManufacturers.set("6,4", this.powerSupply.type64);

        this.batteryDateCodes.set("1,1", this.powerSupply.manufactureDate11);
        this.batteryDateCodes.set("1,2", this.powerSupply.manufactureDate12);
        this.batteryDateCodes.set("1,3", this.powerSupply.manufactureDate13);
        this.batteryDateCodes.set("1,4", this.powerSupply.manufactureDate14);
		    this.batteryDateCodes.set("1,5", this.powerSupply.manufactureDate15);
        this.batteryDateCodes.set("1,6", this.powerSupply.manufactureDate16);
        this.batteryDateCodes.set("2,1", this.powerSupply.manufactureDate21);
        this.batteryDateCodes.set("2,2", this.powerSupply.manufactureDate22);
        this.batteryDateCodes.set("2,3", this.powerSupply.manufactureDate23);
        this.batteryDateCodes.set("2,4", this.powerSupply.manufactureDate24);
        this.batteryDateCodes.set("3,1", this.powerSupply.manufactureDate31);
        this.batteryDateCodes.set("3,2", this.powerSupply.manufactureDate32);
        this.batteryDateCodes.set("3,3", this.powerSupply.manufactureDate33);
        this.batteryDateCodes.set("3,4", this.powerSupply.manufactureDate34);
        this.batteryDateCodes.set("4,1", this.powerSupply.manufactureDate41);
        this.batteryDateCodes.set("4,2", this.powerSupply.manufactureDate42);
        this.batteryDateCodes.set("4,3", this.powerSupply.manufactureDate43);
        this.batteryDateCodes.set("4,4", this.powerSupply.manufactureDate44);
        this.batteryDateCodes.set("5,1", this.powerSupply.manufactureDate51);
        this.batteryDateCodes.set("5,2", this.powerSupply.manufactureDate52);
        this.batteryDateCodes.set("5,3", this.powerSupply.manufactureDate53);
        this.batteryDateCodes.set("5,4", this.powerSupply.manufactureDate54);
        this.batteryDateCodes.set("6,1", this.powerSupply.manufactureDate61);
        this.batteryDateCodes.set("6,2", this.powerSupply.manufactureDate62);
        this.batteryDateCodes.set("6,3", this.powerSupply.manufactureDate63);
        this.batteryDateCodes.set("6,4", this.powerSupply.manufactureDate64);

        this.batterySerial.set("1,1", this.powerSupply.batterySerial11);
        this.batterySerial.set("1,2", this.powerSupply.batterySerial12);
        this.batterySerial.set("1,3", this.powerSupply.batterySerial13);
        this.batterySerial.set("1,4", this.powerSupply.batterySerial14);
        this.batterySerial.set("1,5", this.powerSupply.batterySerial15);
        this.batterySerial.set("1,6", this.powerSupply.batterySerial16);
        this.batterySerial.set("2,1", this.powerSupply.batterySerial21);
        this.batterySerial.set("2,2", this.powerSupply.batterySerial22);
        this.batterySerial.set("2,3", this.powerSupply.batterySerial23);
        this.batterySerial.set("2,4", this.powerSupply.batterySerial24);
        this.batterySerial.set("3,1", this.powerSupply.batterySerial31);
        this.batterySerial.set("3,2", this.powerSupply.batterySerial32);
        this.batterySerial.set("3,3", this.powerSupply.batterySerial33);
        this.batterySerial.set("3,4", this.powerSupply.batterySerial34);
        this.batterySerial.set("4,1", this.powerSupply.batterySerial41);
        this.batterySerial.set("4,2", this.powerSupply.batterySerial42);
        this.batterySerial.set("4,3", this.powerSupply.batterySerial43);
        this.batterySerial.set("4,4", this.powerSupply.batterySerial44);
        this.batterySerial.set("5,1", this.powerSupply.batterySerial51);
        this.batterySerial.set("5,2", this.powerSupply.batterySerial52);
        this.batterySerial.set("5,3", this.powerSupply.batterySerial53);
        this.batterySerial.set("5,4", this.powerSupply.batterySerial54);
        this.batterySerial.set("6,1", this.powerSupply.batterySerial61);
        this.batterySerial.set("6,2", this.powerSupply.batterySerial62);
        this.batterySerial.set("6,3", this.powerSupply.batterySerial63);
        this.batterySerial.set("6,4", this.powerSupply.batterySerial64);

        this.batteryInstallDates.set("1,1", this.powerSupply.installDate11);
        this.batteryInstallDates.set("1,2", this.powerSupply.installDate12);
        this.batteryInstallDates.set("1,3", this.powerSupply.installDate13);
        this.batteryInstallDates.set("1,4", this.powerSupply.installDate14);
		    this.batteryInstallDates.set("1,5", this.powerSupply.installDate15);
        this.batteryInstallDates.set("1,6", this.powerSupply.installDate16);
        this.batteryInstallDates.set("2,1", this.powerSupply.installDate21);
        this.batteryInstallDates.set("2,2", this.powerSupply.installDate22);
        this.batteryInstallDates.set("2,3", this.powerSupply.installDate23);
        this.batteryInstallDates.set("2,4", this.powerSupply.installDate24);
        this.batteryInstallDates.set("3,1", this.powerSupply.installDate31);
        this.batteryInstallDates.set("3,2", this.powerSupply.installDate32);
        this.batteryInstallDates.set("3,3", this.powerSupply.installDate33);
        this.batteryInstallDates.set("3,4", this.powerSupply.installDate34);
        this.batteryInstallDates.set("4,1", this.powerSupply.installDate41);
        this.batteryInstallDates.set("4,2", this.powerSupply.installDate42);
        this.batteryInstallDates.set("4,3", this.powerSupply.installDate43);
        this.batteryInstallDates.set("4,4", this.powerSupply.installDate44);
        this.batteryInstallDates.set("5,1", this.powerSupply.installDate51);
        this.batteryInstallDates.set("5,2", this.powerSupply.installDate52);
        this.batteryInstallDates.set("5,3", this.powerSupply.installDate53);
        this.batteryInstallDates.set("5,4", this.powerSupply.installDate54);
        this.batteryInstallDates.set("6,1", this.powerSupply.installDate61);
        this.batteryInstallDates.set("6,2", this.powerSupply.installDate62);
        this.batteryInstallDates.set("6,3", this.powerSupply.installDate63);
        this.batteryInstallDates.set("6,4", this.powerSupply.installDate64);

        this.batteryVoltages.set("1,1", this.powerSupply.voltage11);
        this.batteryVoltages.set("1,2", this.powerSupply.voltage12);
        this.batteryVoltages.set("1,3", this.powerSupply.voltage13);
        this.batteryVoltages.set("1,4", this.powerSupply.voltage14);
		    this.batteryVoltages.set("1,5", this.powerSupply.voltage15);
        this.batteryVoltages.set("1,6", this.powerSupply.voltage16);
        this.batteryVoltages.set("2,1", this.powerSupply.voltage21);
        this.batteryVoltages.set("2,2", this.powerSupply.voltage22);
        this.batteryVoltages.set("2,3", this.powerSupply.voltage23);
        this.batteryVoltages.set("2,4", this.powerSupply.voltage24);
        this.batteryVoltages.set("3,1", this.powerSupply.voltage31);
        this.batteryVoltages.set("3,2", this.powerSupply.voltage32);
        this.batteryVoltages.set("3,3", this.powerSupply.voltage33);
        this.batteryVoltages.set("3,4", this.powerSupply.voltage34);
        this.batteryVoltages.set("4,1", this.powerSupply.voltage41);
        this.batteryVoltages.set("4,2", this.powerSupply.voltage42);
        this.batteryVoltages.set("4,3", this.powerSupply.voltage43);
        this.batteryVoltages.set("4,4", this.powerSupply.voltage44);
        this.batteryVoltages.set("5,1", this.powerSupply.voltage51);
        this.batteryVoltages.set("5,2", this.powerSupply.voltage52);
        this.batteryVoltages.set("5,3", this.powerSupply.voltage53);
        this.batteryVoltages.set("5,4", this.powerSupply.voltage54);
        this.batteryVoltages.set("6,1", this.powerSupply.voltage61);
        this.batteryVoltages.set("6,2", this.powerSupply.voltage62);
        this.batteryVoltages.set("6,3", this.powerSupply.voltage63);
        this.batteryVoltages.set("6,4", this.powerSupply.voltage64);
        this.batteryManagerModels.push(this.powerSupply.batteryBalancerString);
        // this.batteryManagerModels.push(this.powerSupply.batteryBalancerString1);
        // this.batteryManagerModels.push(this.powerSupply.batteryBalancerString2);
        // this.batteryManagerModels.push(this.powerSupply.batteryBalancerString3);
        // this.batteryManagerModels.push(this.powerSupply.batteryBalancerString4);
        // this.batteryManagerModels.push(this.powerSupply.batteryBalancerString5);
        // this.batteryManagerModels.push(this.powerSupply.batteryBalancerString6);
      } , err => {
        this.showProgressBar = false;
      });
      this.powerSupplyService.getPowerSupplySfpByPowerSupplyId(this.powerSupplyId).subscribe(res => {
        if (res && res != null) {
          this.sfpmacData = res;
        }
      });
  }

  getNwtName(){
    //calling the nwt team api
    if (this.powerSupply != null && this.powerSupply.nodeName != undefined || this.powerSupply.nodeName != null) {
      this.powerSupplyService.getNWTTeams(this.powerSupply.nodeName,this.powerSupply.state).subscribe(resultdata => {
        this.nwtTeamData = resultdata.nwtTeam;
      });
    }
  }

  getAlerts(){
    this.showProgressBar = true;
    this.showcount = false;
    this.powerSupplyAlertsRequest.alertClearType = "B";
    //this.powerSupplyAlertsRequest.alertLevelList = ['alert'];
    this.powerSupplyAlertsRequest.powersupplyId = Number(this.powerSupplyId);
    this.powerSupplyAlertsRequest.historyReq = false;
    this.powerSupplyAlertsRequest.pageNo = 0;
    this.powerSupplyAlertsRequest.rowLimit = 5000;
    this.powerSupplyAlertsRequest.sortBy = "DESC";

    this.psnbApi.getPowerSupplyAlertsList(this.powerSupplyAlertsRequest).subscribe(result => {
      this.alertResult = this.processData(result);
      if(this.alertResult['psAlertsList'].length > 0){
        this.noData = false;
        this.alertResultData = this.alertResult['psAlertsList'];
      }else{
        this.noData = true;
        this.alertResultData = [];
      }
      this.showcount = true;
      this.showProgressBar = false;
    }, err => {
      this.showProgressBar = false;
    });
  }

  getloghistory(){
    this.powerSupplyService.getPSLogHistoryByPSId(this.powerSupplyId)
    .subscribe(result => {
      this.logResult = this.processlogData(result);
      if(this.logResult.length > 0){
        this.nologData = false;
        this.loghistoryData = this.logResult;
      }else{
        this.nologData = true;
        this.loghistoryData = [];
      }
      this.showProgressBar = false;
      const message = `Power Supply Log History by PSID: ${this.powerSupplyId}`;
      const activity = 'Power Supply Log History';
      this.commonService.loggerPost(message, activity, 3);
    }, err => {
      this.showProgressBar = false;
    });
  }

  processlogData(rowlogData){
    this.showProgressBar = true;
    rowlogData.forEach(element => {
      element.logDate = (element.logDate) ? new Date(element.logDate).toLocaleString() : null;
    });
    this.showProgressBar = false;
    return rowlogData;
  }

  processData(rowData) {
    this.showProgressBar = true;
    rowData.psAlertsList.forEach(element => {
      if (element.deviceName && element.deviceType) {
        element.impactedDevices = element.deviceName.replace(/,/g, ', ') + ' - ' + element.deviceType  + ' (Storm)';
      }
      element.alertStartTime = (element.alertStartTime) ? new Date(element.alertStartTime).toLocaleString() : null;
      element.alertEndTime = (element.alertEndTime) ? new Date(element.alertEndTime).toLocaleString() : null;
      element.psExpectedFailureTime = (element.psExpectedFailureTime) ? new Date(element.psExpectedFailureTime).toLocaleString() : null;

      let alertDuration = null;
      if (element.alertDuration) {
        alertDuration = (element.alertDuration > 1) ? 'Mins' : 'Min';
        alertDuration = element.alertDuration + ' ' + alertDuration;
      } else if ( element.alertEndTime && Math.abs(element.alertEndTime - element.alertStartTime) < 100000) {
        alertDuration = '0 Min';
      }
      element.alertDuration =  alertDuration;

      if (!element.deviceName && element.psNodes) {
        element.impactedDevices = element.psNodes + ' - ' + element.deviceType + ' (PSNB)';
      }
    });
    this.showProgressBar = false;
    return rowData;
  }


  getImageDetails(powerSupplyId) {
    this.showProgressBar = true;
    if (powerSupplyId !== null || powerSupplyId !== undefined) {
      // Get PS Images from Image details
      var promises = [];
      this.psImagesService.setImages();
      var psImages = this.psImagesService.getImages();
      this.initializeLatestDateImage();
      this.powerSupplyService.getPsnbSdsImageDetailByPsId(this.powerSupplyId).subscribe(result => {
        result.forEach(psnbimagedata => {
          this.isImageLatest(psnbimagedata.category,psnbimagedata.createDate,psnbimagedata.latestImage);
          promises.push(this.getPsnbImageByPsId(this.powerSupplyId, psnbimagedata.category));
        });
        Promise.all(promises)
          .then(imagesResponse => {
            this.showProgressBar = false;
            result.forEach((imageDetail, key) => {
              let catgry = <any>imageDetail['category'] - 1;
              if(!this.catErrMessage.includes(imageDetail['category'].toString())){
                let objectURL = URL.createObjectURL(imagesResponse[key]);
                psImages[catgry]['url'] = this.sanitizer.bypassSecurityTrustUrl(objectURL);
              }
            });
            this.detailedImage = psImages;
            if(this.catErrMessage.length > 0)
              this.openErrorDialog("Unable to fetch the images for categories: "+ this.catErrMessage.sort());
          })
          .catch((err) => {
            this.showProgressBar = false;
            this.openErrorDialog("Unable to fetch the images");
          });
      }, err => {
        this.showProgressBar = false;
        this.openErrorDialog("Unable to fetch the images");
      });
    }
  }

  getPsnbImageByPsId(powerSupplyId, category) {
    return new Promise((resolve, reject) => {
      this.powerSupplyService.getPsnbSdsImageByPsIdAndCategory(powerSupplyId, category)
        .pipe(map(binaryData => binaryData))
        .subscribe(binaryData => {
          resolve(binaryData);
        }, err => {
          //reject(err);
          this.catErrMessage.push(category);
          resolve('Image Category '+ category +' not able to fetch');
        });
    });
  }

  initializeLatestDateImage(){
    for(let index = 0; index < 11; index++){
      var dataVal: DateAndLatestImage;
      dataVal = {
        latestImage : "No Image",
        uploadedDate : "null"
     }
    this.latestDateDetail.push(dataVal);
    }
  }

  isImageLatest(category,createDate,latestImage){
    let catgry = category -1;
    for(let index = 0; index < this.latestDateDetail.length; index++){
      var dataVal: DateAndLatestImage;
      if(catgry == index){
        if(latestImage === 'Old'){
          dataVal = {
            latestImage : latestImage,
            uploadedDate : createDate != null ? new Date(createDate).toLocaleString(): ''
        }
      } else{
       dataVal = {
          latestImage : latestImage,
          uploadedDate : createDate != null ? new Date(createDate).toLocaleString(): ''
       }
      }
      this.latestDateDetail[index]= dataVal;
    }
  }
}

  openErrorDialog(message: string) {
    this.powerSupplyErrorDialog = this.dialog.open(PowerSupplyMoveErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
  }
  /*Function to get the Power Supply battery data - Detailed view based */
  numberOfBatteriesAndStrings(numberOfBatteries: string) {
    if (numberOfBatteries !== '' && numberOfBatteries !== null && numberOfBatteries !== undefined &&
        numberOfBatteries !== '0 String Of 0') {
      const split: string[] = numberOfBatteries.split(' ');
      if (split != null && split.length > 0) {
        if (split[0] == 'Parallel') {
          this.parallelBatts = true;
        }
      }
      if (this.parallelBatts) {
       this.noOfBatteries = Array(Number(split[1])).fill(0).map((x, i) => i + 1);
       this.noOfStrings = Array(Number('1')).fill(0).map((x, i) => i + 1);
      } else {
        if (numberOfBatteries == '1LionBMS') {
          this.noOfStrings = Array(Number(1)).fill(0).map((x, i) => i + 1);
          this.noOfBatteries = Array(Number(1)).fill(0).map((x, i) => i + 1);
        } else {
          this.noOfStrings = Array(Number(split[0])).fill(0).map((x, i) => i + 1);
          this.noOfBatteries = Array(Number(split[3])).fill(0).map((x, i) => i + 1);
        }
      }
    }
  }

  openGroup(event) {
    if (event === "Show Photos" && this.imagesLoaded === false) {
      this.imagesLoaded = true;
      this.getImageDetails(this.powerSupplyId);
    }
  }
  // onTabChange() {
  //   console.log('hi');
  //   const tab = event.tab.textLabel;
  //   console.log(tab);
  //   // if(tab === "Show Photos" && this.imagesLoaded === false) {
  //   //   this.imagesLoaded = true;
  //   //   this.getImageDetails(this.powerSupplyId);
  //   // }
  // }

  /*Function to go back from detailed view to list view - Detailed view based */
  go_back() {
    this._location.back();
  }

  downloadPDF(){
    this.showProgressBar = true;
    const pdfName = 'XM360_' + this.powerSupplyId + '.pdf';
    this.powerSupplyService.getPsnbSdsPDFImageByPsId(this.powerSupplyId).subscribe(result => {
      if(result != null){
        var blob = new Blob([result], { type: "application/pdf"});
        FileSaver.saveAs(blob, pdfName);
        this.showProgressBar = false;
      } else{
        this.showProgressBar = false;
        this.openErrorDialog("No PDF images to download!");
      }
    }, err => {
      this.showProgressBar = false;
      this.openErrorDialog("No PDF images to download!");
    });
  }

}
